/**
 * Sistema de Animações Fade-In
 * Gerencia animações de entrada baseadas em Intersection Observer
 * Melhora a percepção de valor através de transições suaves e profissionais
 */

class FadeInAnimations {
  constructor() {
    this.observer = null;
    this.init();
  }

  init() {
    // Verifica se o usuário prefere movimento reduzido
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Remove classes de animação para acessibilidade
      document.querySelectorAll('[class*="fade-in"]').forEach(el => {
        el.classList.add('is-visible');
      });
      return;
    }

    // Configuração do Intersection Observer
    const options = {
      root: null,
      rootMargin: '0px 0px -10% 0px', // Animação inicia quando 10% do elemento está visível
      threshold: 0.1
    };

    // Cria o observer
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Opcional: desconectar após animação para melhor performance
          // this.observer.unobserve(entry.target);
        }
      });
    }, options);

    // Observa todos os elementos com classes fade-in
    this.observeElements();
  }

  observeElements() {
    const selectors = [
      '.fade-in-element',
      '.fade-in-image',
      '.fade-in-title',
      '.fade-in-text',
      '.fade-in-button',
      '.fade-in-left',
      '.fade-in-right'
    ];

    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        this.observer.observe(el);
      });
    });
  }

  // Método para observar novos elementos adicionados dinamicamente
  observeNewElements(container) {
    if (!this.observer) return;

    const selectors = [
      '.fade-in-element',
      '.fade-in-image',
      '.fade-in-title',
      '.fade-in-text',
      '.fade-in-button',
      '.fade-in-left',
      '.fade-in-right'
    ];

    selectors.forEach(selector => {
      container.querySelectorAll(selector).forEach(el => {
        if (!el.classList.contains('is-visible')) {
          this.observer.observe(el);
        }
      });
    });
  }

  // Método para animar elementos filhos em sequência
  animateChildren(parent, baseDelay = 0, delayIncrement = 0.1) {
    if (!parent || !this.observer) return;

    const children = Array.from(parent.children);
    children.forEach((child, index) => {
      if (!child.classList.contains('fade-in-element')) {
        child.classList.add('fade-in-element');
      }
      
      // Adiciona delay progressivo
      const delay = baseDelay + (index * delayIncrement);
      if (delay > 0) {
        child.style.transitionDelay = `${delay}s`;
      }
      
      this.observer.observe(child);
    });
  }
}

// Inicializa quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.fadeInAnimations = new FadeInAnimations();
  });
} else {
  window.fadeInAnimations = new FadeInAnimations();
}

// Observa mudanças no DOM para novos elementos (útil para páginas dinâmicas)
if (window.MutationObserver) {
  const mutationObserver = new MutationObserver((mutations) => {
    if (window.fadeInAnimations) {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            window.fadeInAnimations.observeNewElements(node);
            
            // Se o próprio node tem classes fade-in
            if (node.classList && Array.from(node.classList).some(cls => cls.startsWith('fade-in'))) {
              window.fadeInAnimations.observeNewElements(node.parentElement || document.body);
            }
          }
        });
      });
    }
  });

  // Observa mudanças em todo o documento
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

export default FadeInAnimations;

